/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React, {ReactNode} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import classnames from 'classnames';
import {toggleThemeStyle} from '../../theme/helpers';

const useStyles = makeStyles(() => ({
  bank : {
    alignItems    : toggleThemeStyle('center', 'flex-start'),
    boxSizing     : 'border-box',
    display       : 'flex',
    flexDirection : toggleThemeStyle('row', 'column'),
    gap           : toggleThemeStyle('0px', '10px'),
    height        : toggleThemeStyle('auto', '60px'),
    padding       : toggleThemeStyle('0px', '8px 24px')
  },
  controls : {
    alignItems     : 'center',
    display        : 'flex',
    flexDirection  : 'row',
    gap            : toggleThemeStyle('0px', '8px'),
    height         : toggleThemeStyle('auto', '44px'),
    justifyContent : toggleThemeStyle('center', 'flex-end'),
    width          : toggleThemeStyle('auto', '100%')
  }
}));

export interface GridControlsBankProps {
  children: ReactNode;
  className?: string;
  controlsClassName?: string;
}

/**
 * Renders the theme-aware grid controls icon bank used above grids.
 */
export const GridControlsBank = ({
  children,
  className,
  controlsClassName
}: GridControlsBankProps) => {
  const classes = useStyles();

  return (
    <div className={classnames(classes.bank, className)}>
      <div className={classnames(classes.controls, controlsClassName)}>
        {children}
      </div>
    </div>
  );
};

export default GridControlsBank;
